import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { analytics } from "@silvertours/front-entities";
import { Ui } from "@silvertours/front-shared";
var Footer = function(param) {
    var _translations = param.translations, newUserHref = _translations.newUserHref, newUserText = _translations.newUserText, noAccountText = _translations.noAccountText, isLoggedIn = param.isLoggedIn;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            noAccountText,
            " ",
            /*#__PURE__*/ _jsx(Ui.TextLink, {
                href: newUserHref,
                text: newUserText,
                onClick: function() {
                    return analytics.gtm.trackNewUser({
                        isLoggedIn: isLoggedIn
                    });
                }
            })
        ]
    });
};
export { Footer };
